var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m95.339 482.772h45.965v-115.331-49.97h-22.968-22.997v49.97z",
    fill: "#6f6571",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m370.667 482.772h45.994v-115.331-49.97h-22.997-22.997v49.97z",
    fill: "#6f6571",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m61.29 512h114.092c2.504 0 4.548-2.071 4.548-4.574v-16.139c0-11.363-9.325-20.684-20.694-20.684h-17.931-45.966-17.902c-11.398 0-20.723 9.321-20.723 20.684v16.139c0 2.503 2.072 4.574 4.576 4.574z",
    fill: "#eceaec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m336.618 512h114.092c2.504 0 4.548-2.071 4.548-4.574v-16.139c0-11.363-9.297-20.684-20.694-20.684h-17.902-45.994-17.902c-11.398 0-20.694 9.321-20.694 20.684v16.139c-.001 2.503 2.042 4.574 4.546 4.574z",
    fill: "#eceaec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m118.336 372.245v98.358h17.902 5.066v-98.358z",
    fill: "#5d5360",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m118.336 329.64v42.605h22.968v-4.804-37.801z",
    fill: "#5d5360",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m432.289 491.287v16.139c0 2.503-2.072 4.574-4.576 4.574h22.997c2.504 0 4.548-2.071 4.548-4.574v-16.139c0-11.363-9.297-20.684-20.694-20.684h-17.902-5.094c1.756 0 3.454.23 5.094.633 8.95 2.272 15.627 10.414 15.627 20.051z",
    fill: "#dad8db",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m393.664 372.245v98.358h17.902 5.095v-98.358z",
    fill: "#5d5360",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m393.664 329.64v42.605h22.997v-4.804-37.801z",
    fill: "#5d5360",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m152.385 512h22.997c2.504 0 4.548-2.071 4.548-4.574v-16.139c0-11.363-9.325-20.684-20.694-20.684h-17.931-5.066c11.398 0 20.694 9.321 20.694 20.684v16.139c0 2.503-2.044 4.574-4.548 4.574z",
    fill: "#dad8db",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m497.538 364.634h-27.445v-34.994c0-4.204-3.407-7.611-7.612-7.611s-7.611 3.408-7.611 7.611v34.994h-122.441v-34.994c0-4.204-3.407-7.611-7.612-7.611s-7.611 3.408-7.611 7.611v34.994h-53.595v-34.994c0-4.204-3.407-7.611-7.612-7.611-4.204 0-7.611 3.408-7.611 7.611v34.994h-53.623v-34.994c0-4.204-3.408-7.611-7.612-7.611s-7.611 3.408-7.611 7.611v34.994h-122.441v-34.994c0-4.204-3.408-7.611-7.611-7.611s-7.611 3.408-7.611 7.611v34.994h-27.417c-4.204 0-7.611 3.408-7.611 7.612s3.408 7.611 7.611 7.611h483.076c4.204 0 7.612-3.408 7.612-7.611s-3.408-7.612-7.612-7.612z",
    fill: "#c8c5c9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m491.811 329.64v-299.129c0-3.049-2.504-5.552-5.584-5.552-287.676 0-178.822 0-460.482 0-3.051 0-5.584 2.503-5.584 5.552v299.129z",
    fill: "#eceaec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m62.816 287.035h386.368v-219.471h-82.633-112.364-112.394-78.977z",
    fill: "#9fd4fe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m141.793 94.22c-4.204 0-7.611-3.408-7.611-7.611v-78.998c0-4.204 3.408-7.611 7.611-7.611 4.204 0 7.611 3.408 7.611 7.611v78.997c.001 4.204-3.407 7.612-7.611 7.612z",
    fill: "#c8c5c9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m254.187 94.22c-4.204 0-7.611-3.408-7.611-7.611v-78.998c0-4.204 3.408-7.611 7.611-7.611s7.611 3.408 7.611 7.611v78.997c0 4.204-3.408 7.612-7.611 7.612z",
    fill: "#c8c5c9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m366.551 94.22c-4.204 0-7.611-3.408-7.611-7.611v-78.998c0-4.204 3.407-7.611 7.611-7.611s7.612 3.408 7.612 7.611v78.997c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "#c8c5c9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m129.475 96.015h24.637c10.966 0 19.946-8.976 19.946-19.936 0-10.961-8.98-19.907-19.946-19.907h-12.319-12.319c-10.966 0-19.917 8.947-19.917 19.907 0 10.961 8.952 19.936 19.918 19.936z",
    fill: "#ffe07d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m266.505 96.015c10.966 0 19.946-8.976 19.946-19.936 0-10.961-8.98-19.907-19.946-19.907h-12.319-12.319c-10.966 0-19.946 8.947-19.946 19.907 0 10.961 8.98 19.936 19.946 19.936z",
    fill: "#ffe07d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m378.87 96.015c10.966 0 19.946-8.976 19.946-19.936 0-10.961-8.98-19.907-19.946-19.907h-12.319-12.319c-10.966 0-19.917 8.947-19.917 19.907 0 10.961 8.951 19.936 19.917 19.936z",
    fill: "#ffe07d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m423.022 67.564h26.163v219.471h-26.163z",
    fill: "#72bffc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m423.022 30.511v37.053h26.163v219.471h-26.076-.086v42.605h39.46 29.329v-299.129c0-3.049-2.504-5.552-5.584-5.552h-63.119z",
    fill: "#dad8db",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoster);
export default __webpack_public_path__ + "static/media/poster.ef820af4637b63debafeea72820e1f74.svg";
export { ForwardRef as ReactComponent };